const PROXY_MAP = {
    development: {
        web: 'http://192.168.0.235:9045',
        file: 'http://192.168.0.235:12035',
        yzkj: 'https://www.yunzikongjian.com',
    },
    production: {
        // web: 'http://192.168.0.235:9045',
        // file: 'http://192.168.0.235:12035',
        web: 'https://huizhao.yunzikongjian.com',
        file: 'https://huizhao.yunzikongjian.com',
        yzkj: 'https://www.yunzikongjian.com',
    }
};

const PROXY_ENV = PROXY_MAP[process.env.NODE_ENV];

import CONFIG_PROJECT from './project';

export default {
    head: {
        title: CONFIG_PROJECT.title,
        meta: {
            description: CONFIG_PROJECT.description,
            keywords: CONFIG_PROJECT.title,
        },
        icon: '/favicon.ico'
    },
    plugins: {
        element: true,
        myComs: true,
        vuexStorage: false,
        jquery: true,
        sentry: false,
        cnzz: {
            id: '1281239458',
        },
    },
    proxy: {
        '/web': {
            target: PROXY_ENV.web,
            changeOrigin: true,
            pathRewrite: {
                '^/': '/'
            }
        },
        // 需要启动nginx统一代理下列路径
        // /upload至文件目录
        // /RootFilePath至文件目录
        // standlonfile至文件接口
        '/standalonfile': {
            target: PROXY_ENV.file,
            changeOrigin: true,
            pathRewrite: {
                '^/': '/'
            }
        },
        '/upload': {
            target: PROXY_ENV.file,
            changeOrigin: true,
            pathRewrite: {
                '^/': '/'
            }
        },
        '/RootFilePath': {
            target: PROXY_ENV.file,
            changeOrigin: true,
            pathRewrite: {
                '^/': '/'
            }
        },
        '/ueditor': {
            target: PROXY_ENV.file,
            changeOrigin: true,
            pathRewrite: {
                '^/': '/'
            }
        },
        '/yzkj': {
            target: PROXY_ENV.yzkj,
            changeOrigin: true,
            pathRewrite: {
                '^/': '/'
            }
        },
    },
}
